exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_menu_eSBYEaQe39Q0KF90NFTeE {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  position: absolute;\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 2;\n}\n\n.IA_menuPanel_AqmZXQDrI4BhR2AFttrG1 {\n  width: 85%;\n  position: absolute;\n  transition: left 200ms ease-out;\n  box-sizing: border-box;\n  padding-top: 10px;\n  z-index: 1000003;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_menu": "IA_menu_eSBYEaQe39Q0KF90NFTeE",
	"IA_menuPanel": "IA_menuPanel_AqmZXQDrI4BhR2AFttrG1"
};